import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function BrandIntro() {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('opacity-100', 'translate-y-0');
          el.classList.remove('opacity-0', 'translate-y-8');
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative w-full min-h-[460px] md:min-h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20newsroom%20with%20warm%20ambient%20lighting%2C%20geometric%20shapes%20and%20floating%20video%20frames%2C%20cinematic%20atmosphere%2C%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20soft%20glow%20effects%2C%20professional%20composition%2C%20dark%20background%20with%20warm%20light%20accents&width=1600&height=800&seq=about-hero-01&orientation=landscape"
          alt="关于吃瓜视频"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70" />
      </div>

      <div
        ref={contentRef}
        className="relative z-10 w-full px-4 md:px-6 opacity-0 translate-y-8 transition-all duration-700 ease-out"
      >
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/20 border border-primary-500/30 mb-5">
              <i className="ri-information-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium">About Us</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              关于
              <span className="text-primary-400">吃瓜视频</span>
              <br />
              全网独家资源
            </h1>
            <p className="text-background-200 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              吃瓜视频是国内领先的娱乐八卦视频资讯平台。我们致力于为吃瓜群众提供最新、最快、最全的网红翻车、明星八卦、热门爆料视频内容。
              每日更新海量免费吃瓜视频，让每位瓜友都能第一时间吃到最新鲜的瓜。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
            >
              返回首页
              <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
            </Link>
          </div>

          <div className="flex-1 hidden lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20creative%20team%20workspace%20with%20warm%20ambient%20lighting%2C%20abstract%20collaboration%20atmosphere%2C%20geometric%20shapes%2C%20editorial%20style%2C%20soft%20warm%20coral%20and%20amber%20tones%2C%20professional%20composition&width=700&height=500&seq=about-side-01&orientation=landscape"
              alt="吃瓜视频团队"
              className="w-full aspect-[4/3] rounded-3xl object-cover object-top border border-background-200/10"
            />
          </div>
        </div>
      </div>
    </section>
  );
}